import {
	VBtn,
	VStepper,
	VStepperContent,
	VStepperStep,
	VSubheader
} from "vuetify/lib";
import { KSignableInput } from "kinnect-general";
import {
	formatDate,
	formatTime
} from "kinnect-formatters";

export default {
	name: "KStatusStepper",

	props: {
		loading: Boolean,
		modelStatus: {
			required: true,
			type: String
		},
		modelStatuses: {
			required: true,
			type: Array,
			validator: statuses => statuses.every( status =>
				typeof status === "object"
					&& status.hasOwnProperty( "created_at" )
					&& status.hasOwnProperty( "name" )
			)
		},
		readonly: Boolean,
		requiresSignature: Boolean,
		signatureLabel: {
			default: "Signature",
			type: String
		},
		statuses: {
			required: true,
			type: Array,
			validator: statuses => statuses.every( status =>
				typeof status === "object"
				&& typeof status.text === "string"
				&& typeof status.value === "string"
			)
		},
		title: {
			default: "Mark As",
			type: String
		}
	},

	data: vm => ( {
		signatures: vm.statuses.reduce( ( obj, status ) => {
			obj[status.value] = null;
			return obj;
		}, {} )
	} ),

	computed: {
		user() {
			return this.$store.getters["auth/user"];
		},

		statusStepNum() {
			const steps = {};

			this.statuses.forEach( ( status, i ) => {
				steps[status.value] = i + 1;
			} );

			return steps;
		},

		getSteps() {
			const items = [];

			this.statuses.forEach( ( status, i ) => {
				items.push(
					this.genStep( status, i + 1 ),
					this.genStepContent( status, i + 1 )
				);
			} );

			return items;
		}
	},

	methods: {
		getModelStatus( status ) {
			if ( status && status.value ) {
				return this.modelStatuses.find( modelStatus => modelStatus.name === status.value );
			}
		},

		genStatusTime( status ) {
			const modelStatus = this.getModelStatus( status );

			if ( modelStatus ) {
				return <span class="text-caption">
					(<span class="text-no-wrap">{formatDate( modelStatus.created_at )}</span> at <span class="text-no-wrap">{formatTime( modelStatus.created_at )}</span>)
				</span>;
			}
		},

		genStep( status, stepNum ) {
			const complete = this.statusStepNum[this.modelStatus] >= stepNum;

			return <VStepperStep
				complete={complete}
				editable={complete}
				step={stepNum}
			>
				<span>{status.text}</span>
				{this.genStatusTime( status )}
			</VStepperStep>;
		},

		genStepContent( status, stepNum ) {
			const statusIndex = this.statuses.findIndex( item => item.value === status.value );
			const nextStatus = this.statuses[statusIndex + 1];
			const nextModelStatus = nextStatus ? this.getModelStatus( nextStatus ) : null;
			const isCurrentStep = status.value === this.modelStatus;
			const isLastStep = status.value === this.statuses[this.statuses.length - 1].value;

			if ( isLastStep ) {
				return;
			}

			return <VStepperContent step={stepNum}>
				{this.requiresSignature && <KSignableInput
					class="mb-1"
					immutable
					readonly={this.readonly}
					selectProps={{
						hideDetails: true,
						itemText: "name",
						label: this.signatureLabel
					}}
					userSignedBy={nextModelStatus ? nextModelStatus.userSetBy : null}
					value={nextModelStatus ? nextModelStatus.idUserSetBy : this.signatures[status.value]}
					onInput={val => {
						if ( isCurrentStep ) {
							this.signatures[status.value] = val;
						}
					}}
				></KSignableInput>}

				{isCurrentStep && !this.readonly && <VBtn
					color="primary"
					depressed
					disabled={this.requiresSignature && !this.signatures[status.value]}
					loading={this.loading}
					onClick={() => this.$emit(
						"update:modelStatus",
						this.statuses[stepNum].value
					)}
				>Mark Step as Completed</VBtn>}
			</VStepperContent>;
		}
	},

	render() {
		return <VStepper value={this.statusStepNum[this.modelStatus]} vertical>
			{Boolean( this.title ) && <VSubheader>{this.title}</VSubheader>}
			{this.getSteps}
		</VStepper>;
	}
};
